import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@neworg-net/amsuite-core/config';
import { Observable } from 'rxjs';

import { PartyVisitSummary } from '../models';
import { requireHostUrl } from '../shared/required-host-url';

/** Adapter di sola lettura: Bearer, owner e impersonazione restano negli interceptor condivisi. */
@Injectable({ providedIn: 'root' })
export class CrmPartyVisitsService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  getVisited(): Observable<PartyVisitSummary[]> {
    return this.get('visited-parties');
  }

  getMoreVisited(): Observable<PartyVisitSummary[]> {
    return this.get('most-visited-parties');
  }

  private get(resource: 'visited-parties' | 'most-visited-parties'): Observable<PartyVisitSummary[]> {
    const url = `${requireHostUrl(this.config, 'crmRead').replace(/\/$/, '')}/crm/v1/me/${resource}`;
    return this.http.get<PartyVisitSummary[]>(url, { params: new HttpParams().set('limit', 20) });
  }
}
